const textFieldModalDocEmployee = {
  label: 'Empresa'
};

export default textFieldModalDocEmployee;
